import { Col, Collapse, Row } from "antd";
import { Trans, useTranslation } from "react-i18next";
import {
  formatNoSignObject,
  moneyFormatObject,
  signByCurrency,
} from "shared/helpers/BRLFormat";
import LogoStrm from "shared/assets/images/strm-logo-verde-gradient.png";
import ImagemSessaoIntermediaria from "shared/assets/images/adiantamento-sessao-intermediaria.png";
import { useSelector } from "react-redux";
import { isMobile } from "react-device-detect";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { ReactComponent as Clock } from "shared/assets/images/clock-eight.svg";
import { ReactComponent as AdiantamentoPassoUm } from "shared/assets/images/adiantamento-inicio-passo-um.svg";
import { ReactComponent as AdiantamentoPassoDois } from "shared/assets/images/adiantamento-inicio-passo-dois.svg";
import { ReactComponent as AdiantamentoPassoTres } from "shared/assets/images/adiantamento-inicio-passo-tres.svg";
import { ReactComponent as AdiantamentoPassoQuatro } from "shared/assets/images/adiantamento-inicio-passo-quatro.svg";
import Duvidas from "./Duvidas";

import { CashAdvanceAvailableEnum } from "shared/enums/CashAdvanceAvailable";
import { getSpecialCampaign } from "shared/helpers/special-campaign-helpers";
import { SpecialCampaignEnum } from "shared/enums/SpecialCampaignEnum";
import { ClientSpecialCampaignApprovalEnum } from "shared/enums/ClientSpecialCampaignApprovalEnum";
import {
  dataLayerClickedEvent,
  dataLayerViewedEvent,
  tagManagerEvent,
} from "event-tracker/gtm-events";
import { canAskAdvance } from "explorer/reducers/adiantamentos";
import { useEffect } from "react";
import { AdvanceButtonClickEventName } from "event-tracker/button-click-event-name";
import { formatDateByLanguage } from "shared/helpers/date-format-helpers";

interface AdiantamentoInicioProps {
  createAdvance: any;
}
const AdiantamentoInicio: React.FC<AdiantamentoInicioProps> = (props) => {
  const { createAdvance } = props;
  const { t, i18n } = useTranslation();
  const { loggedUser } = useSelector((state: any) => state.users);
  const noQuiz = loggedUser?.userArtists?.length < 1;

  const { userArtist, loading } = useSelector((state: any) => state.artists);
  const { cashAdvanceAvailable, loading: advanceLoading } = useSelector(
    (state: any) => state.advances
  );

  const advanceAmount = `${signByCurrency(
    userArtist?.cashAdvanceEstimated?.currency
  )} ${formatNoSignObject({
    currency: userArtist?.cashAdvanceEstimated?.currency,
    amount:
      userArtist?.cashAdvanceEstimated?.amount /
      userArtist?.cashAdvanceEstimated?.trancheFactor,
  })}`;

  const specialCampaignHenriqueJuliano = getSpecialCampaign(
    userArtist?.specialCampaign,
    SpecialCampaignEnum.HenriqueEJuliano
  );
  const specialCampaignKamillaFialho = getSpecialCampaign(
    userArtist?.specialCampaign,
    SpecialCampaignEnum.KamillaFialho
  );
  const specialCampaignAnnoDomini = getSpecialCampaign(
    userArtist?.specialCampaign,
    SpecialCampaignEnum.AnnoDomini
  );

  const specialCampaign =
    specialCampaignHenriqueJuliano ||
    specialCampaignKamillaFialho ||
    specialCampaignAnnoDomini;

  const onClickIniciaProcesso = async () => {
    createAdvance(true);
    dataLayerClickedEvent(AdvanceButtonClickEventName.REQUEST, {
      ...tagManagerEvent.Advance.S4A_ADVANCE_INDEX,
      carreerStage: userArtist?.stage,
      approvedLimit: userArtist?.cashAdvanceEstimated?.amountUsd,
      alreadyCalculated:
        userArtist?.cashAdvanceEstimated?.successfullyEstimated,
      country: userArtist?.country,
    });
  };

  const mensagemSemAcesso = () => {
    if (
      cashAdvanceAvailable === CashAdvanceAvailableEnum.NotAvailable ||
      cashAdvanceAvailable === CashAdvanceAvailableEnum.NotFound
    )
      return t("pages.Adiantamentos.naoCumpreRequisitosMensagem", {
        currency: signByCurrency(userArtist?.cashAdvanceEstimated?.currency),
      });

    if (cashAdvanceAvailable === CashAdvanceAvailableEnum.NeedRetry)
      return t("pages.Adiantamentos.tentarNovamenteEmbreve");

    // if (cashAdvanceAvailable === CashAdvanceAvailableEnum.NotFound)
    //   return t("pages.Adiantamentos.spotifyNaoEncontrado");

    if (!loggedUser?.cashAdvanceFeatureAvailable)
      return t("pages.Adiantamentos.funcionalidadeNaoDisponivel");

    if (noQuiz) return t("pages.Adiantamentos.semArtista");

    if (!userArtist?.spotifyId)
      return t("pages.Adiantamentos.artistaSemSpotify");

    if (specialCampaign?.approval === ClientSpecialCampaignApprovalEnum.Pending)
      return t("pages.Adiantamentos.campanhaEspecialPendente");
  };

  const carregando: boolean = loading || advanceLoading;

  const permissaoBotaoCTA = () => {
    const byPassAdiantamentoUsuario = !!loggedUser?.isCashAdvanceAvailable;
    const funcionalideDisponivel = !!loggedUser?.cashAdvanceFeatureAvailable;
    const artistaElegivel = canAskAdvance(cashAdvanceAvailable);
    const campanhaEspecialBloqueada =
      specialCampaign?.approval === ClientSpecialCampaignApprovalEnum.Pending;

    return (
      byPassAdiantamentoUsuario ||
      (funcionalideDisponivel && artistaElegivel && !campanhaEspecialBloqueada)
    );
  };

  const faqList: any[] = t("pages.Adiantamentos.faqInicio");

  useEffect(() => {
    dataLayerViewedEvent({
      ...tagManagerEvent.Advance.S4A_ADVANCE_INDEX,
    });
  }, []);

  return (
    <div className={`adiantamentos inicio ${!isMobile && "web"}`}>
      <div className="header">
        <div className="logo-container">
          <img src={LogoStrm} alt="" />
        </div>
        <h1 className="title">{t("pages.Adiantamentos.titulo")}</h1>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            maxWidth: isMobile ? "unset" : 650,
          }}
        >
          <Row gutter={[0, 0]}>
            <Col xs={20} className={`branco`} style={{ marginTop: 48 }}>
              <h3 className="apresentacao">
                <b>
                  <Trans i18nKey={t(`pages.Adiantamentos.apresentacao`)} />
                </b>
              </h3>
              <p className="paragrafo-com-verde">
                <Trans i18nKey={t(`pages.Adiantamentos.texto`)} />
              </p>
            </Col>
            {!permissaoBotaoCTA() && (
              <div className="pending-info">
                <Clock style={{ flex: 2 }} />
                <span style={{ flex: 20 }}>
                  <Trans i18nKey={mensagemSemAcesso()} />
                </span>
              </div>
            )}
            {(loggedUser?.isCashAdvanceAvailable ||
              canAskAdvance(cashAdvanceAvailable) ||
              carregando) && (
              <Col xs={20} className="branco">
                <h2
                  style={{
                    fontWeight: 400,
                    margin: 0,
                    fontSize: 14,
                    marginBottom: ".6rem",
                  }}
                >
                  <Trans
                    i18nKey={
                      loading || advanceLoading
                        ? t("pages.Adiantamentos.calculandoValores")
                        : t("pages.Adiantamentos.disponivel")
                    }
                  />
                </h2>
                <div
                  className={`box-money ${noQuiz && "blur"}`}
                  style={{ marginTop: ".6rem" }}
                >
                  <span
                    className={`green money-format ${
                      loading || advanceLoading ? "loading" : ""
                    }`}
                  >
                    {userArtist?.cashAdvanceEstimated?.trancheFactor > 1 &&
                      `${userArtist?.cashAdvanceEstimated?.trancheFactor}x `}
                    {advanceAmount}
                    {` `}
                    {!userArtist.cashAdvanceEstimated?.calculatedOn &&
                      userArtist?.cashAdvanceEstimated?.trancheFactor === 1 && (
                        <>*</>
                      )}
                  </span>
                  {userArtist?.cashAdvanceEstimated?.trancheFactor > 1 && (
                    <>
                      <span
                        className={`money-format ${
                          loading || advanceLoading ? "loading" : ""
                        }`}
                      >
                        ({moneyFormatObject(userArtist?.cashAdvanceEstimated)})
                        {!userArtist.cashAdvanceEstimated?.calculatedOn && (
                          <>*</>
                        )}
                      </span>
                      <span style={{ display: "block", marginTop: 8 }}>
                        {t("pages.Adiantamentos.recebeParcela", {
                          amount: advanceAmount,
                        })}
                      </span>
                    </>
                  )}
                  {userArtist.cashAdvanceEstimated?.calculatedOn && (
                    <p style={{ marginTop: ".6rem" }}>
                      {t("pages.Adiantamentos.disclaimerCalculadoEm", {
                        data: formatDateByLanguage(
                          userArtist.cashAdvanceEstimated.calculatedOn,
                          i18n.language
                        ),
                        interpolation: { escapeValue: false },
                      })}
                      <br />
                      {t("pages.Adiantamentos.disclaimerValidade")}
                    </p>
                  )}
                  {!userArtist.cashAdvanceEstimated?.calculatedOn && (
                    <span style={{ display: "block", marginTop: 10 }}>
                      {t("pages.Adiantamentos.valoresSujeitoAlteracoes")}
                    </span>
                  )}
                </div>
                {permissaoBotaoCTA() && (
                  <div style={{ marginTop: "1.3rem" }}>
                    <button
                      className="botao-roxo"
                      disabled={loading || advanceLoading}
                      onClick={onClickIniciaProcesso}
                    >
                      {t("pages.Adiantamentos.solicitarAgora")}
                    </button>
                  </div>
                )}
              </Col>
            )}
          </Row>

          <Row className="perks">
            <h1 className="title" style={{ fontSize: 20 }}>
              {t("pages.Adiantamentos.comoAdiantamentoFunciona")}
            </h1>
            <div className="lista-funcionamento">
              <div className="funcionamento">
                <div className="image">
                  <AdiantamentoPassoDois />
                </div>
                <p>
                  <Trans i18nKey={t("pages.Adiantamentos.funcionamentoDois")} />
                </p>
              </div>
              <div className="funcionamento">
                <div className="image">
                  <AdiantamentoPassoUm />
                </div>
                <p>
                  <Trans i18nKey={t("pages.Adiantamentos.funcionamentoUm")} />
                </p>
              </div>
              <div className="funcionamento">
                <div className="image">
                  <AdiantamentoPassoTres />
                </div>
                <p>
                  <Trans i18nKey={t("pages.Adiantamentos.funcionamentoTres")} />
                </p>
              </div>
              <div className="funcionamento">
                <div className="image">
                  <AdiantamentoPassoQuatro />
                </div>
                <p>
                  <Trans
                    i18nKey={t("pages.Adiantamentos.funcionamentoQuatro")}
                  />
                </p>
              </div>
            </div>
          </Row>

          <Row>
            <img
              src={ImagemSessaoIntermediaria}
              alt=""
              className="sessao-intermediaria"
            />
          </Row>

          <Row className="perks">
            <h1 className="title" style={{ fontSize: 20 }}>
              {t("pages.Adiantamentos.beneficios")}
            </h1>
            <ul>
              <li
                className="circle-checkmark roxo"
                style={{ color: "#CECDFF" }}
              >
                {t("pages.Adiantamentos.adiantamentoInicioHighlightUm")}
              </li>
              <li
                className="circle-checkmark roxo"
                style={{ color: "#CECDFF" }}
              >
                {t("pages.Adiantamentos.adiantamentoInicioHighlightDois")}
              </li>
              <li
                className="circle-checkmark roxo"
                style={{ color: "#CECDFF" }}
              >
                {t("pages.Adiantamentos.adiantamentoInicioHighlightTres")}
              </li>
            </ul>
          </Row>
          {permissaoBotaoCTA() && (
            <div>
              <button
                className="botao-roxo"
                disabled={loading || advanceLoading}
                onClick={onClickIniciaProcesso}
              >
                {t("pages.Adiantamentos.solicitarAgora")}
              </button>
            </div>
          )}
          <Row>
            <Col
              xs={24}
              style={{
                marginTop: 32,
              }}
            >
              <h3 className="apresentacao">
                <Trans i18nKey={"pages.Adiantamentos.stepsTitle"} />
              </h3>
              <ol className="lista-passos">
                <li>
                  <span>
                    <Trans i18nKey={t("pages.Adiantamentos.stepUm")} />
                  </span>
                </li>
                <li>
                  <span>
                    <Trans i18nKey={t("pages.Adiantamentos.stepDois")} />
                  </span>
                </li>
                <li>
                  <span>
                    <Trans i18nKey={t("pages.Adiantamentos.stepTres")} />
                  </span>
                </li>
                <li>
                  <span>
                    <Trans i18nKey={t("pages.Adiantamentos.stepQuatro")} />
                  </span>
                </li>
                <li>
                  <span>
                    <Trans i18nKey={t("pages.Adiantamentos.stepCinco")} />
                  </span>
                </li>
              </ol>
            </Col>
          </Row>
          <Row>
            <Col
              xs={24}
              style={{
                marginTop: 26,
                marginBottom: 50,
              }}
            >
              {permissaoBotaoCTA() && (
                <button
                  className="botao-roxo"
                  disabled={loading}
                  onClick={onClickIniciaProcesso}
                >
                  {t("pages.Adiantamentos.solicitarAgora")}
                </button>
              )}
            </Col>
          </Row>
          <Row>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <span
                style={{ display: "block", marginBottom: 24, color: "#F2F2F2" }}
              >
                {t("pages.Adiantamentos.aindaComDuvidasFAQ")}
              </span>
              <span
                style={{ display: "blick", marginBottom: 12, color: "#F2F2F2" }}
              >
                {t("pages.Adiantamentos.faqTitle")}
              </span>
            </div>
            <Collapse
              bordered={false}
              className="faq"
              expandIcon={() => <FontAwesomeIcon icon={faChevronDown} />}
              expandIconPosition="end"
            >
              {faqList?.map((faq, i) => (
                <Collapse.Panel
                  header={t(`pages.Adiantamentos.faq.${faq}.pergunta`)}
                  key={i}
                >
                  <p>
                    <Trans
                      i18nKey={t(`pages.Adiantamentos.faq.${faq}.resposta`)}
                    />
                  </p>
                </Collapse.Panel>
              ))}
            </Collapse>
          </Row>
          <Row>
            <Col
              xs={24}
              style={{
                margin: "45px 0",
              }}
            >
              {permissaoBotaoCTA() && (
                <button
                  className="botao-roxo"
                  disabled={loading}
                  onClick={onClickIniciaProcesso}
                >
                  {t("pages.Adiantamentos.solicitarAgora")}
                </button>
              )}
            </Col>
          </Row>
          <Row justify="center" style={{ marginBottom: 32 }} className="footer">
            <Duvidas />
          </Row>
        </div>
      </div>
    </div>
  );
};

export default AdiantamentoInicio;
